import Vue from 'vue'
import { upperFirst, camelCase } from 'lodash'

// 只匹配components目录下的index.vue文件
const requireComponent = require.context('@/components', true, /index\.vue$/)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)
    // 获取组件名称
    const componentName = upperFirst(
        camelCase(
        // 使用第一级目录名作为组件名称
        fileName.split('/')[1]
        )
    )
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，
        // 否则回退到使用模块的根。
        componentConfig.default || componentConfig
    )
})